import type { ProjectCommentListResponsePage } from './projectCommentListResponsePage';

/**
 * 프로젝트 댓글 목록 응답 데이터
 */
export interface ProjectCommentListResponse {
  /** 응답 코드 (성공 또는 에러 식별) */
  code?: string;
  /** 응답 메시지 */
  message?: string;
  page?: ProjectCommentListResponsePage;
  success?: boolean;
}
